import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import { Collection } from '../../interfaces/collection.interface'

@Component({
  selector: 'app-collection-card',
  templateUrl: './collection-card.component.html',
  styleUrls: ['./collection-card.component.scss']
})
export class CollectionCardComponent implements OnInit {

  @Input() collection: Collection
  @Input() admin = false
  @Output() deleted = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  get link() {
    return `/${this.collection.id}`
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/shared/components/collection-card/collection-card.component.ts